/* Wishlist page (sections/bt-page-wishlist.liquid). Port of the loader + page in
   eu-hydrogen/app/routes/($locale).wishlist.tsx: handles come from BT.wishlist (localStorage),
   products from /products/<handle>.js, cards from the <template> in the section (markup and classes live in Liquid).
   Order follows localStorage; at most 100 handles, like the Hydrogen loader. Needs assets/theme.js (window.BT). */
(function () {
  'use strict';

  var page = document.querySelector('[data-bt-wishlist-page]');
  var BT = window.BT;
  if (!page || !BT || !BT.wishlist) return;

  var config = window.BT_CONFIG || {};
  var rootUrl = (config.routes && config.routes.root) || '/';
  var prefix = rootUrl === '/' ? '' : rootUrl.replace(/\/$/, '');

  var empty = page.querySelector('[data-bt-wishlist-empty]');
  var skeleton = page.querySelector('[data-bt-wishlist-skeleton]');
  var results = page.querySelector('[data-bt-wishlist-results]');
  var grid = page.querySelector('[data-bt-wishlist-grid]');
  var total = page.querySelector('[data-bt-wishlist-total]');
  var template = page.querySelector('template[data-bt-wishlist-card]');
  if (!empty || !skeleton || !results || !grid || !template) return;

  var cache = {}; // handle -> product JSON, or null when the product no longer exists
  var run = 0;

  function show(state) {
    empty.hidden = state !== 'empty';
    skeleton.hidden = state !== 'loading';
    results.hidden = state !== 'results';
  }

  function productUrl(handle) {
    return prefix + '/products/' + encodeURIComponent(handle);
  }

  function load(handle) {
    if (Object.prototype.hasOwnProperty.call(cache, handle)) return Promise.resolve(cache[handle]);
    return fetch(productUrl(handle) + '.js', {headers: {Accept: 'application/json'}})
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; })
      .then(function (product) {
        cache[handle] = product;
        return product;
      });
  }

  // Same crop as Hydrogen's <Image aspectRatio="3/4">: width + height + crop=center.
  function sized(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width + '&height=' + Math.round((width * 4) / 3) + '&crop=center';
  }

  function imageAlt(product) {
    var media = (product.media || []).filter(function (item) { return item.media_type === 'image'; })[0];
    return (media && media.alt) || '';
  }

  function card(product) {
    var node = template.content.firstElementChild.cloneNode(true);
    var image = node.querySelector('[data-bt-wishlist-image]');
    node.querySelector('[data-bt-wishlist-link]').setAttribute('href', productUrl(product.handle));
    node.querySelector('[data-bt-wishlist-title]').textContent = product.title;
    node.querySelector('[data-bt-wishlist-price]').textContent = BT.money(product.price_min != null ? product.price_min : product.price);
    node.querySelector('[data-bt-wishlist-button]').setAttribute('data-bt-wishlist', product.handle);
    if (product.featured_image) {
      image.alt = imageAlt(product);
      image.srcset = [240, 480, 720].map(function (width) { return sized(product.featured_image, width) + ' ' + width + 'w'; }).join(', ');
      image.src = sized(product.featured_image, 480);
    } else {
      image.parentNode.removeChild(image);
    }
    return node;
  }

  function render() {
    var handles = BT.wishlist.all().slice(0, 100);
    var current = ++run;
    if (!handles.length) {
      grid.textContent = '';
      show('empty');
      return;
    }
    if (!grid.children.length) show('loading');
    Promise.all(handles.map(load)).then(function (products) {
      if (current !== run) return;
      var found = products.filter(Boolean);
      grid.textContent = '';
      found.forEach(function (product) { grid.appendChild(card(product)); });
      if (total) total.textContent = String(found.length);
      // Every saved product is gone from the shop: nothing to list, so fall back to the empty state.
      show(found.length ? 'results' : 'empty');
      BT.wishlist.repaint();
    });
  }

  document.addEventListener('bt:wishlist:updated', render);
  window.addEventListener('storage', render);
  render();
})();
